import * as React from "react";
import styled from "styled-components";
import AutoLink from "./AutoLink";

export type StyledInputProps = {
  component: keyof React.ReactHTML;
  editable?: boolean;
  value: string;
  multiLine?: boolean;
  autolink?: boolean;
  onChange(text: string): void;
} & Omit<React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>, "onChange">;

class StyledInput extends React.PureComponent<StyledInputProps> {
  public static defaultProps: Partial<StyledInputProps> = {
    autolink: true,
  };

  private textarea: HTMLTextAreaElement | null = null;

  public componentDidUpdate() {
    this.resize();
  }

  public componentDidMount() {
    this.resize();
  }

  public onChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { onChange, multiLine } = this.props;
    let text = event.currentTarget.value;
    if (!multiLine) {
      text = text.replace(/\r?\n|\r/g, "");
    }
    onChange!(text);
  };

  public resize() {
    if (!this.textarea) {
      return;
    }
    this.textarea.style.height = "auto";
    this.textarea.style.height = `${this.textarea.scrollHeight}px`;
  }

  public render() {
    const { component: Component, editable, value, onChange, autolink, multiLine, ...rest } = this.props;
    if (editable) {
      return (
        <Textarea
          value={value}
          onChange={this.onChange}
          innerRef={(ref: any) => (this.textarea = ref)}
          rows={1}
          {...rest}
        />
      );
    }
    return <Component {...rest as any}>{autolink ? <AutoLink text={value} /> : value}</Component>;
  }
}

const Textarea: any = styled.textarea`
  display: block;
  padding: 0;
  border: none;
  resize: none;
  &:focus {
    border: none;
  }
`;

export default StyledInput;



// WEBPACK FOOTER //
// ./frontend/src/common/components/StyledInput.tsx